module.exports = __webpack_public_path__ + "img/main_hy.cf345bf1.png";